import { useDebounce } from "hooks/useDebounce";
import { useDispatch, useSelector } from "react-redux";
import { actions as servicePaymentsActions } from "reducers/servicePayments";

export const useCompanies = () => {
    const dispatch = useDispatch();
    const { companies, fetchingCompanies, selectedCompany } = useSelector((state) => state.servicePayments);
    const { companyName } = selectedCompany;
    const debouncedAction = servicePaymentsActions.searchCompany;
    const { onChangeDebounce: debounceCompany } = useDebounce({ debouncedAction });

    const handleCompanyInputChange = (input) => {
        if (input.length >= 3) {
            debounceCompany(input);
        }
    };

    const handleCompanyChange = (companyCode, resetForm, initialValues) => {
        if (companyCode) {
            const _companyName = companies.find((company) => company.value === companyCode).label;
            dispatch(servicePaymentsActions.getPaymentModes(companyCode));
            dispatch(servicePaymentsActions.setSelectedCompany({ companyCode, companyName: _companyName }));
        } else {
            dispatch(servicePaymentsActions.clearCompany());
        }
        resetForm({ ...initialValues });
    };

    return { companyName, companies, fetchingCompanies, handleCompanyInputChange, handleCompanyChange };
};

export default useCompanies;
